import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { useCallback, useEffect, useRef } from 'react';

/**
 * Useful for deferring the return value of submission callbacks until you have the data to perform
 * the submission.
 * @param resolver Will run every time the queue wants to check if it can resolve its queued up promises.
 * Return { resolveWith: O } to trigger the queue to start resolving its promises.
 * @param dependencyList whenever one of the items in this list changes, the {@param resolver} will be run
 */
export var useCallbackPromiseQueue = function useCallbackPromiseQueue(resolver) {
  var resolveQueueRef = useRef([]);
  useEffect(function () {
    // Try resolve with the new resolver
    resolveQueueRef.current = resolveQueueRef.current.filter(function (_ref) {
      var input = _ref.input,
          resolve = _ref.resolve;
      var output = resolver.apply(void 0, _toConsumableArray(input));

      if (output === undefined) {
        return true;
      }

      resolve(output.resolveWith);
      return false;
    });
  }, [resolver]);
  /**
   * This will return a promise that will resolve the next time the
   * {@link resolver} returns an object with "resolveWith" in it.
   */

  var enqueue = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _len,
        input,
        _key,
        initialResolverOutput,
        queuedPromise,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            for (_len = _args.length, input = new Array(_len), _key = 0; _key < _len; _key++) {
              input[_key] = _args[_key];
            }

            initialResolverOutput = resolver.apply(void 0, input);

            if (!(initialResolverOutput !== undefined)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", initialResolverOutput.resolveWith);

          case 4:
            queuedPromise = new Promise(function (resolve) {
              return resolveQueueRef.current.push({
                input: input,
                resolve: resolve
              });
            });
            return _context.abrupt("return", queuedPromise);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [resolver] // TODO: We only have to do this because resolving a promise creates Promise<Promise<...>>
  );
  return enqueue;
};